import { Icon } from "../Icon/Icon";

const TabListItem = ({ isActive, children, onClick }) => {
	return (
		<div
			onClick={onClick}
			className={`flex-1 Subtitle1 flex flex-col justify-center items-center cursor-pointer relative pb-2`}
		>
			<span className={`${isActive ? "text-[#404040]" : "text-[#cccccc]"}`}>
				{children}
			</span>
			{isActive && (
				<div className="absolute bottom-0 left-0 w-full h-[1px] bg-[#404040]" />
			)}
		</div>
	);
};

export const Tab = ({ tabs, activeTab, setActiveTab, className = "" }) => {
	return (
		<div
			className={`flex justify-center px-0 py-[12px] items-start self-stretch gap-[20px] bg-white shadow-[0_1px_0_0_#EEE] overflow-x-auto scrollbar-hide ${className}`}
		>
			{tabs.map((tab, index) => (
				<TabListItem
					key={index}
					isActive={activeTab === index}
					onClick={() => setActiveTab(index)}
				>
					<span className="whitespace-nowrap overflow-hidden text-ellipsis">
						{tab}
					</span>
				</TabListItem>
			))}
		</div>
	);
};

export const ChipTab = ({
	tabs, // { name: string, iconName: string }[]
	activeTab, // number
	setActiveTab,
}) => {
	return (
		<div className="flex items-start gap-2">
			{tabs.map((tab, index) => (
				<div
					key={index}
					className={`py-[8px] px-[16px] flex items-center justify-center gap-2 bg-[#404040] text-white rounded-[24px] ${
						activeTab === index ? "bg-[#F5F5F5] text-ContentPrimary" : ""
					}`}
					onClick={() => setActiveTab(index)}
				>
					{tab.iconName && (
						<Icon
							iconName={tab.iconName}
							size="Small"
							color={activeTab === index ? "#404040" : "#FFFFFF"}
						/>
					)}
					<span
						className={`text-[14px] leading-[18px] whitespace-nowrap ${activeTab === index ? "text-ContentPrimary" : "text-white"}`}
					>
						{tab.name}
					</span>
				</div>
			))}
		</div>
	);
};
